<template>
  <transition
    name="flash"
    appear
  >
    <div
      class="headlines--titles"
      :style="`--duration:${10*itemList.length}s`"
    >
      <ul>
        <li
          v-for="(item, index) in itemList"
          :key="index"
          attr="row1"
        >
          {{ item }}
        </li>
      </ul>
      <ul>
        <li
          v-for="(item, index) in itemList"
          :key="index"
          attr="row2"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'HeadlinesBanner',
  props: {
    items: { type: Array, default: () => [] },
  },
  computed: {
    itemList() {
      let list = this.items.concat(this.items);
      while (list.length < 10) {
        list = list.concat(this.items);
      }
      return list;
    },
  },
};
</script>
<style lang="stylus" scoped>
.headlines--titles {
  display: flex;
  background: $cl-yellow
  overflow: hidden;
  width: 100%;
  flex-shrink: 0;
  height: 38px;

  position: relative;

  +vue-transition("flash", 1200ms, $ease-out-quint) {
    width: 0%
  }

  +desktop() {
    flex-shrink: 1!important;
  }

  ul {
    display: flex;
    padding: 0 0 0 10px;
    align-items: center;
    color: black;
    gap: 10px;
    list-style: none;
    width: auto;
    flex-shrink: 0;
    position: relative;

    animation: slide-left var(--duration, 10s) linear infinite;
    animation-delay: calc(-1 * var(--duration, 10s));

    &:last-child {
      animation-delay: 0s;
    }

      @keyframes slide-left {
        0% {
          transform: translateX(0)
        }
        100% {
          transform: translateX(-100%)
        }
      }


    li {
      display: flex;
      gap: 10px;
      flex-shrink: 0;
      align-items: center;
      font-size: 23px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 2.76px;
      text-transform: uppercase;


      &:before {
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: black;
      }
    }
  }
}
</style>
